/* ============================================================================
   FSR-Media – Custom JS für flammtal (Impact 7.0.1)
   Hier liegt die Logik der Rewards-Bar (<flammtal-rewards>), weil Skripte in
   per innerHTML nachgeladenem Drawer-HTML nicht ausgeführt werden.
   ============================================================================ */
(function () {
  if (window.customElements.get('flammtal-rewards')) return;

  var busy = null;

  // Section-IDs des Drawers so einsammeln, wie Impact es selbst macht (Section-Group-IDs wie
  // "sections--123__cart-drawer"), damit das Re-Render per cart:change funktioniert.
  function bundledSectionIds() {
    var list = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: list } }));
    return list;
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function postJson(path, body) {
    return fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    });
  }

  class FlammtalRewards extends HTMLElement {
    connectedCallback() {
      var self = this;
      setTimeout(function () { self.sync(); }, 150);
    }

    async sync() {
      if (!this.isConnected) return;
      // Läuft gerade ein Abgleich, warten und danach mit eigenen Daten erneut prüfen
      // (der Abgleich prüft vor jedem Request den echten Warenkorb, daher keine Doppelungen).
      if (busy) {
        try { await busy; } catch (e) { /* ignorieren */ }
        if (!this.isConnected) return;
      }
      var add = (this.getAttribute('data-add') || '').split(',').filter(Boolean).map(function (v) { return parseInt(v, 10); });
      var remove = (this.getAttribute('data-remove') || '').split(',').filter(Boolean);
      if (add.length === 0 && remove.length === 0) return;
      busy = this._run(add, remove).finally(function () { busy = null; });
      await busy;
    }

    async _run(add, remove) {
      window.isUpdatingCartGifts = true;
      try {
        var cart = await (await fetch(root() + 'cart.js')).json();
        var gifts = cart.items.filter(function (i) { return i.properties && i.properties._auto_gift === 'true'; });
        var toRemove = remove.filter(function (k) { return cart.items.some(function (i) { return i.key === k; }); });
        var toAdd = add.filter(function (v) { return !gifts.some(function (i) { return i.variant_id === v; }); });
        if (toRemove.length === 0 && toAdd.length === 0) return;

        var sectionIds = bundledSectionIds();
        var sectionsParam = sectionIds.join(',');
        var last = null;
        if (toRemove.length > 0) {
          var updates = {};
          toRemove.forEach(function (k) { updates[k] = 0; });
          last = await postJson('cart/update.js', { updates: updates, sections: sectionsParam });
        }
        if (toAdd.length > 0) {
          last = await postJson('cart/add.js', {
            items: toAdd.map(function (id) { return { id: id, quantity: 1, properties: { _auto_gift: 'true' } }; }),
            sections: sectionsParam
          });
        }
        if (last && !last.ok) {
          var err = await last.json().catch(function () { return {}; });
          throw new Error(err.description || ('Cart-Request fehlgeschlagen (' + last.status + ')'));
        }
        var json = last ? await last.json() : null;
        var fresh = await (await fetch(root() + 'cart.js')).json();
        fresh.sections = json && json.sections ? json.sections : null;

        var hasSections = fresh.sections && sectionIds.length > 0 && sectionIds.every(function (id) { return !!fresh.sections[id]; });
        if (hasSections) {
          // Sofortiges Re-Render des Drawers (ohne die 1,25 s Verzögerung von Impact bei Mengenänderungen)
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', cart: fresh }
          }));
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      } catch (error) {
        console.error('[Flammtal Rewards]', error);
      } finally {
        setTimeout(function () { window.isUpdatingCartGifts = false; }, 300);
      }
    }
  }

  window.customElements.define('flammtal-rewards', FlammtalRewards);
})();
